/* ══ NESET.JS — Shopify Theme JavaScript ══
   SPA kalıntıları temizlendi. Tüm sayfa yönlendirmeleri
   dosyanın sonundaki Shopify override'ları tarafından yapılır.
*/
/* ══════════════════════════════════ */

/* ── STATE ── */
let userLoggedIn=false,currentPDP='quarona',savedItems=[];

/* ══════════════════════════════════════
   KVKK / ÇEREZ BANNER
══════════════════════════════════════ */
function cookieInit(){
  if(localStorage.getItem('ns_cookie'))return;
  setTimeout(()=>{
    const banner=document.getElementById('cookie-banner');
    if(banner)banner.classList.add('show');
  },1200);
}
function cookieChoice(choice){
  localStorage.setItem('ns_cookie',choice);
  const banner=document.getElementById('cookie-banner');
  if(banner){banner.classList.remove('show');}
}
document.addEventListener('DOMContentLoaded',cookieInit);

/* ══════════════════════════════════════
   STİCKY HEADER — SCROLL HIDE/SHOW
   Ana sayfa + PDP içi scroll için ortak mantık
══════════════════════════════════════ */
const _navEl=document.getElementById('site-nav');
let _lastWinY=0,_winTicking=false;
let _pdpScrollEl=null; // aktif PDP scroll dinleyicisi

function _applyScrollHide(y,lastY,el){
  if(y>80){
    el.classList.add('compact');
    if(y>lastY&&y>160){el.classList.add('hidden');}
    else if(y<lastY){el.classList.remove('hidden');}
  }else{
    el.classList.remove('compact','hidden');
  }
}

// Window scroll (ana sayfa / koleksiyon / editorial sayfalar)
function _onWinScroll(){
  if(_pdpScrollEl)return; // PDP açıkken window scroll'u yoksay
  if(!_winTicking){
    requestAnimationFrame(()=>{
      _applyScrollHide(window.scrollY,_lastWinY,_navEl);
      _lastWinY=window.scrollY;
      _winTicking=false;
    });
    _winTicking=true;
  }
}
window.addEventListener('scroll',_onWinScroll,{passive:true});

// PDP kendi scroll container'ından header'ı yönetir
let _lastPdpY=0,_pdpTicking=false;
function _onPdpScroll(){
  if(!_pdpScrollEl)return;
  if(!_pdpTicking){
    requestAnimationFrame(()=>{
      const y=_pdpScrollEl.scrollTop;
      _applyScrollHide(y,_lastPdpY,_navEl);
      _lastPdpY=y;
      _pdpTicking=false;
    });
    _pdpTicking=true;
  }
}
function _attachPdpScroll(el){
  _pdpScrollEl=el;
  _lastPdpY=0;
  el.addEventListener('scroll',_onPdpScroll,{passive:true});
}
function _detachPdpScroll(){
  if(_pdpScrollEl){
    _pdpScrollEl.removeEventListener('scroll',_onPdpScroll);
    _pdpScrollEl=null;
    _lastPdpY=0;
  }
}
const products={
  dustin:{name:'Dustin Pantolon',mat:'İpek, Pamuk, Keten',price:'₺ 18.500',color:'#6B8FA8',desc:'İpek-pamuk-keten karışımından üretilen bu özel pantolon, mevsimin en sofistike kesimlerinden birini sunuyor.'},
  pushkar:{name:'Pushkar Pantolon',mat:'Pamuk, Keten',price:'₺ 13.400',color:'#7A8060',desc:'Rahat kesimi ve keten dokusuyla günlük zarafeti yeniden tanımlayan elastik bel bantlı model.'},
  marlyn:{name:'Marlyn Pantolon',mat:'Keten',price:'₺ 15.900',color:'#7A9882',desc:'%100 keten yapısıyla nefes alabilen, doğal dokusuyla öne çıkan klasik kesim pantolon.'},
  quarona:{name:'Quarona Beş Cepli',mat:'Pamuk, Keten',price:'₺ 14.200',color:'#B8956A',desc:'İlkbahar ve yaz için tasarlanan bu regular-fit, beş cepli pantolonlar %70 pamuk, %30 keten karışımından üretilmiştir.'},
  altai:{name:'Altai Pantolon',mat:'İpek, Keten',price:'₺ 22.000',color:'#4A5060',desc:'İpek-keten harmanıyla üretilmiş formal kesim, özel toplantılar ve gece davetleri için tasarlandı.'},
  belem:{name:'Belem Pantolon',mat:'Pamuk',price:'₺ 11.500',color:'#C4B8A0',desc:'%100 organik pamuktan dokuma bu regular-fit pantolon, günün her anına rahatlık ve şıklık katıyor.'},
  ceylan:{name:'Ceylan Pantolon',mat:'Keten',price:'₺ 17.800',color:'#D4C8B0',desc:'Ekru renginde %100 keten formal pantolon. Yazlık etek-ceket kombinlerine mükemmel eşlik eder.'},
  destan:{name:'Destan Pantolon',mat:'Pamuk, Keten',price:'₺ 12.900',color:'#A09080',desc:'Pamuk-keten karışımı slim fit yapısıyla gündelik ve yarı resmi kombinler için idealdir.'},
};

/* ── PAGES ── */
function showPage(id){
  // PDP açıksa kapat
  const pdp=document.getElementById('pdp-layer');
  if(pdp&&pdp.classList.contains('open')){
    pdp.classList.remove('open');
    document.body.style.overflow='';
  }
  document.querySelectorAll('.page').forEach(p=>p.classList.remove('active'));
  const p=document.getElementById('page-'+id);
  if(p){p.classList.add('active');window.scrollTo({top:0,behavior:'smooth'});}
  else{document.getElementById('page-home').classList.add('active');}
  if(id==='pantolonlar'){initCollPage();}
  // Yeni aktif sayfadaki editorial görsellere reveal uygula
  setTimeout(applyImgReveal,50);
}
function goHome(){showPage('home');}

/* ── PDP ── */
const _matPageMap={'İpek':'ipek','Pamuk':'pamuk','Keten':'keten'};
function openPDP(id){
  currentPDP=id;
  const p=products[id]||products.quarona;
  document.getElementById('pdp-name').textContent=p.name;
  // Kumaş isimlerine tıklanabilir link ekle
  const matHtml=p.mat.split(', ').map(m=>{
    const pg=_matPageMap[m];
    return pg?`<a onclick="showPage('${pg}')" style="color:var(--navy);cursor:pointer;text-decoration:underline;text-underline-offset:3px;text-decoration-color:rgba(26,43,66,.35);transition:text-decoration-color .2s;" onmouseover="this.style.textDecorationColor='var(--navy)'" onmouseout="this.style.textDecorationColor='rgba(26,43,66,.35)'">${m}</a>`:m;
  }).join(', ');
  document.getElementById('pdp-mat').innerHTML=matHtml;
  document.getElementById('pdp-price').textContent=p.price;
  document.getElementById('pdp-desc').textContent=p.desc;
  document.getElementById('pdp-bc').textContent='Ana Sayfa / Koleksiyon / '+p.name;

  // Önerilen ürünler — mevcut ürün hariç 4 ürün
  const recKeys=Object.keys(products).filter(k=>k!==id).slice(0,4);
  const svgMap={
    dustin:`<svg width="120" height="180" viewBox="0 0 130 240" fill="none"><rect x="35" y="0" width="60" height="11" rx="3" fill="#7A9BB5" opacity="0.5"/><path d="M35 11 L22 240 L57 240 L65 100 L73 240 L108 240 L95 11 Z" fill="#6B8FA8" opacity="0.72"/></svg>`,
    pushkar:`<svg width="120" height="180" viewBox="0 0 130 240" fill="none"><rect x="32" y="0" width="66" height="10" rx="5" fill="#7A8060" opacity="0.5"/><path d="M34 10 L22 240 L58 240 L65 98 L72 240 L108 240 L96 10 Z" fill="#7A8060" opacity="0.7"/></svg>`,
    marlyn:`<svg width="120" height="180" viewBox="0 0 130 240" fill="none"><rect x="38" y="0" width="54" height="10" rx="3" fill="#8FAA98" opacity="0.5"/><path d="M38 10 L26 240 L60 240 L65 95 L70 240 L104 240 L92 10 Z" fill="#7A9882" opacity="0.7"/></svg>`,
    quarona:`<svg width="120" height="180" viewBox="0 0 130 240" fill="none"><rect x="34" y="0" width="62" height="12" rx="3" fill="#C4A87A" opacity="0.35"/><path d="M37 12 L24 240 L60 240 L65 95 L70 240 L106 240 L93 12 Z" fill="#E8E4DC" opacity="0.55"/></svg>`,
    altai:`<svg width="120" height="180" viewBox="0 0 130 240" fill="none"><rect x="36" y="0" width="58" height="11" rx="3" fill="#4A5060" opacity="0.4"/><path d="M36 11 L24 240 L59 240 L65 96 L71 240 L106 240 L94 11 Z" fill="#4A5060" opacity="0.72"/></svg>`,
    belem:`<svg width="120" height="180" viewBox="0 0 130 240" fill="none"><rect x="35" y="0" width="60" height="10" rx="3" fill="#C4B8A0" opacity="0.5"/><path d="M35 10 L23 240 L58 240 L65 97 L72 240 L107 240 L95 10 Z" fill="#C4B8A0" opacity="0.7"/></svg>`,
    ceylan:`<svg width="120" height="180" viewBox="0 0 130 240" fill="none"><rect x="36" y="0" width="58" height="10" rx="3" fill="#D4C8B0" opacity="0.5"/><path d="M37 10 L25 240 L59 240 L65 96 L71 240 L105 240 L93 10 Z" fill="#D4C8B0" opacity="0.72"/></svg>`,
    destan:`<svg width="120" height="180" viewBox="0 0 130 240" fill="none"><rect x="37" y="0" width="56" height="10" rx="3" fill="#A09080" opacity="0.5"/><path d="M38 10 L26 240 L60 240 L65 96 L70 240 L104 240 L92 10 Z" fill="#A09080" opacity="0.7"/></svg>`,
  };
  const recGrid=document.getElementById('pdp-rec-grid');
  recGrid.innerHTML=recKeys.map(k=>{
    const rp=products[k];
    return `<div class="pdp-rec-card" onclick="openPDP('${k}')">
      <div class="pdp-rec-img"><div class="pdp-rec-img-inner" style="background:var(--cream2);">${svgMap[k]||''}</div></div>
      <div class="pdp-rec-info">
        <div class="pdp-rec-mat">${rp.mat}</div>
        <div class="pdp-rec-name">${rp.name}</div>
        <div class="pdp-rec-price">${rp.price}</div>
      </div>
    </div>`;
  }).join('');

  const l=document.getElementById('pdp-layer');
  l.classList.add('open');l.scrollTop=0;
  // Site-nav'ı göster ve PDP scroll dinleyicisini bağla
  if(_navEl){_navEl.classList.remove('hidden','compact');}
  _attachPdpScroll(l);
  // Mobil bar güncelle
  const mobName=document.getElementById('pdp-mob-name');
  const mobPrice=document.getElementById('pdp-mob-price');
  if(mobName)mobName.textContent=p.name;
  if(mobPrice)mobPrice.textContent=p.price;
  document.body.style.overflow='hidden';
  // Save butonunu senkronize et
  const saveBtn=document.getElementById('pdp-save-btn');
  if(saveBtn){saveBtn.classList.toggle('saved',savedItems.includes(id));saveBtn.style.transform='';}
} /* /openPDP */
function closePDP(){
  document.getElementById('pdp-layer').classList.remove('open');
  document.body.style.overflow='';
  _detachPdpScroll();
  // Ana sayfa scroll pozisyonuna göre header durumunu güncelle
  if(_navEl){
    if(window.scrollY<=80){_navEl.classList.remove('hidden','compact');}
    else{_navEl.classList.remove('hidden');}
  }
}
function pickColor(el,name){document.querySelectorAll('.sw').forEach(s=>s.classList.remove('active'));el.classList.add('active');document.getElementById('col-name').textContent=name;}
function pickSz(el){document.querySelectorAll('.sz:not(.na)').forEach(b=>b.classList.remove('sel'));el.classList.add('sel');}
function togAcc(btn){const b=btn.nextElementSibling;const open=b.classList.contains('open');document.querySelectorAll('.acc-body').forEach(x=>x.classList.remove('open'));if(!open)b.classList.add('open');}
function togFaq(btn){const a=btn.nextElementSibling;const open=a.classList.contains('open');document.querySelectorAll('.faq-a').forEach(x=>x.classList.remove('open'));if(!open)a.classList.add('open');}

/* ── SEPET SİSTEMİ ── */
let cartItems=[];
const _cartSvg={
  dustin:`<svg width="50" height="70" viewBox="0 0 130 240" fill="none"><rect x="35" y="0" width="60" height="11" rx="3" fill="#6B8FA8" opacity=".5"/><path d="M35 11 L22 240 L57 240 L65 100 L73 240 L108 240 L95 11 Z" fill="#6B8FA8" opacity=".72"/></svg>`,
  pushkar:`<svg width="50" height="70" viewBox="0 0 130 240" fill="none"><rect x="32" y="0" width="66" height="10" rx="5" fill="#7A8060" opacity=".5"/><path d="M34 10 L22 240 L58 240 L65 98 L72 240 L108 240 L96 10 Z" fill="#7A8060" opacity=".7"/></svg>`,
  marlyn:`<svg width="50" height="70" viewBox="0 0 130 240" fill="none"><rect x="38" y="0" width="54" height="10" rx="3" fill="#8FAA98" opacity=".5"/><path d="M38 10 L26 240 L60 240 L65 95 L70 240 L104 240 L92 10 Z" fill="#7A9882" opacity=".7"/></svg>`,
  quarona:`<svg width="50" height="70" viewBox="0 0 130 240" fill="none"><rect x="34" y="0" width="62" height="12" rx="3" fill="#C4A87A" opacity=".35"/><path d="M37 12 L24 240 L60 240 L65 95 L70 240 L106 240 L93 12 Z" fill="#E8E4DC" opacity=".55"/></svg>`,
  altai:`<svg width="50" height="70" viewBox="0 0 130 240" fill="none"><rect x="36" y="0" width="58" height="11" rx="3" fill="#4A5060" opacity=".4"/><path d="M36 11 L24 240 L59 240 L65 96 L71 240 L106 240 L94 11 Z" fill="#4A5060" opacity=".72"/></svg>`,
  belem:`<svg width="50" height="70" viewBox="0 0 130 240" fill="none"><rect x="35" y="0" width="60" height="10" rx="3" fill="#C4B8A0" opacity=".5"/><path d="M35 10 L23 240 L58 240 L65 97 L72 240 L107 240 L95 10 Z" fill="#C4B8A0" opacity=".7"/></svg>`,
  ceylan:`<svg width="50" height="70" viewBox="0 0 130 240" fill="none"><rect x="36" y="0" width="58" height="10" rx="3" fill="#D4C8B0" opacity=".5"/><path d="M37 10 L25 240 L59 240 L65 96 L71 240 L105 240 L93 10 Z" fill="#D4C8B0" opacity=".72"/></svg>`,
  destan:`<svg width="50" height="70" viewBox="0 0 130 240" fill="none"><rect x="37" y="0" width="56" height="10" rx="3" fill="#A09080" opacity=".5"/><path d="M38 10 L26 240 L60 240 L65 96 L70 240 L104 240 L92 10 Z" fill="#A09080" opacity=".7"/></svg>`,
};

function addToCart(id){
  const p=products[id];if(!p)return;
  const sz=document.querySelector('#pdp-layer .sz.sel');
  const size=sz?sz.textContent:'32';
  const existing=cartItems.find(i=>i.id===id&&i.size===size);
  if(existing){existing.qty=(existing.qty||1)+1;}
  else{cartItems.push({id,size,qty:1});}
  _updateCartBadge();
  // Buton feedback
  const btn=document.querySelector('.btn-cart');
  if(btn){
    const orig=btn.textContent;
    btn.textContent='✓  Sepete Eklendi';
    btn.classList.add('added');
    setTimeout(()=>{btn.textContent=orig;btn.classList.remove('added');},2200);
  }
  // Kısa gecikme sonra sepeti aç
  setTimeout(()=>openCartPanel(),450);
}

function _updateCartBadge(){
  const badge=document.getElementById('cart-badge');
  if(!badge)return;
  const total=cartItems.reduce((s,i)=>s+(i.qty||1),0);
  badge.textContent=total;
  badge.classList.toggle('show',total>0);
  badge.classList.remove('pop');
  void badge.offsetWidth;
  if(total>0)badge.classList.add('pop');
}

function openCartPanel(){
  closeAllPanels(true);
  const body=document.getElementById('cart-panel-body');
  const countEl=document.getElementById('cart-count-title');
  const total=cartItems.reduce((s,i)=>s+(i.qty||1),0);
  if(countEl)countEl.textContent=total>0?`(${total})`:'';

  if(!cartItems.length){
    body.innerHTML=`<div class="panel-empty">
      <div class="panel-empty-icon"><svg width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="var(--border)" stroke-width="1"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg></div>
      <div class="panel-empty-title">Sepetiniz Boş</div>
      <p class="panel-empty-text">Koleksiyonumuzu keşfederek başlayın.</p>
      <button class="panel-cta" onclick="closeAllPanels();showPage('pantolonlar')">Koleksiyona Git</button>
    </div>`;
  } else {
    let html=cartItems.map(item=>{
      const p=products[item.id]||{};
      return`<div class="cart-item">
        <div class="cart-item-img">${_cartSvg[item.id]||''}</div>
        <div>
          <div class="cart-item-name">${p.name||''}</div>
          <div class="cart-item-det">${p.mat||''} &nbsp;·&nbsp; Beden ${item.size}${item.qty>1?' &nbsp;×&nbsp;'+item.qty:''}</div>
          <div class="cart-item-price">${p.price||''}</div>
        </div>
        <button class="cart-remove" onclick="removeFromCart('${item.id}','${item.size}')">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M18 6L6 18M6 6l12 12"/></svg>
        </button>
      </div>`;
    }).join('');

    const subtotal=cartItems.reduce((s,i)=>{
      const pr=products[i.id];if(!pr)return s;
      const num=parseInt(pr.price.replace(/[^\d]/g,''))||0;
      return s+num*(i.qty||1);
    },0);
    const fmtPrice=n=>n.toLocaleString('tr-TR');

    html+=`<div class="cart-total-wrap">
      <div class="cart-shipping-bar">
        ${(()=>{
          const FREE_THRESHOLD=5000;
          const pct=Math.min(subtotal/FREE_THRESHOLD*100,100);
          const remaining=FREE_THRESHOLD-subtotal;
          const statusText=subtotal>=FREE_THRESHOLD
            ? '✓ Ücretsiz kargo kazandınız!'
            : '₺ '+fmtPrice(remaining)+' daha ekleyin, kargo bedava';
          return`<div class="cart-shipping-bar-top">
            <span class="cart-shipping-bar-label">Kargo</span>
            <span class="cart-shipping-bar-status">${statusText}</span>
          </div>
          <div class="cart-progress-track"><div class="cart-progress-fill" style="width:${pct}%"></div></div>`;
        })()}
      </div>
      <div class="cart-total-row"><span>Ara Toplam</span><span>₺ ${fmtPrice(subtotal)}</span></div>
      <div class="cart-total-row"><span>Kargo</span><span style="color:var(--navy);">Ücretsiz</span></div>
      <div class="cart-total-final">
        <span class="cart-total-lbl">Toplam</span>
        <span class="cart-total-price">₺ ${fmtPrice(subtotal)}</span>
      </div>
      <button class="cart-checkout-btn">Siparişi Tamamla</button>
      <div class="cart-trust-row">
        <span>🔒 Güvenli SSL</span>
        <span class="cart-trust-sep">·</span>
        <span>Ücretsiz İade</span>
        <span class="cart-trust-sep">·</span>
        <span>Ücretsiz Kargo</span>
      </div>
    </div>`;
    body.innerHTML=html;
  }

  document.getElementById('cart-panel').classList.add('open');
  document.getElementById('panel-overlay').classList.add('open');
  document.body.style.overflow='hidden';
}

function removeFromCart(id,size){
  cartItems=cartItems.filter(i=>!(i.id===id&&i.size===size));
  _updateCartBadge();
  openCartPanel();
}

/* ── LIGHTBOX ── */
let lbIndex=0,lbImgs=[],lbScale=1,lbX=0,lbY=0,lbDragging=false,lbDragSX=0,lbDragSY=0,lbDragOX=0,lbDragOY=0;
function openLightbox(idx){
  const gallery=document.getElementById('pdp-gallery');
  lbImgs=Array.from(gallery.querySelectorAll('.gal-img'));
  lbIndex=idx;
  lbScale=1.5;lbX=0;lbY=0;
  const thumbsEl=document.getElementById('lb-thumbs');
  thumbsEl.innerHTML=lbImgs.map((img,i)=>{
    const clone=img.cloneNode(true);
    const hint=clone.querySelector('.gal-zoom-hint');
    if(hint)hint.remove();
    clone.style.cssText='width:52px;height:70px;display:flex;align-items:center;justify-content:center;pointer-events:none;overflow:hidden;';
    clone.querySelectorAll('svg').forEach(s=>{s.style.cssText='max-width:50px;max-height:68px;width:auto;height:auto;';});
    clone.querySelectorAll('div').forEach(d=>{d.style.pointerEvents='none';});
    return `<div class="lb-thumb-item${i===idx?' active':''}" data-idx="${i}" onclick="lbGoTo(${i})">${clone.outerHTML}</div>`;
  }).join('');
  renderLbImg();
  document.getElementById('img-lightbox').classList.add('open');
  document.body.style.overflow = 'hidden';
  const hint=document.getElementById('lb-hint');
  if(hint) {
    hint.style.opacity='1';
    setTimeout(()=>hint.style.opacity='0',2800);
  }
}
function closeLightbox(){
  document.getElementById('img-lightbox').classList.remove('open');
  document.body.style.overflow = '';
  lbScale=1;lbX=0;lbY=0;
  if(_header) _header.style.transform = 'translateY(0)';
}
function lbNav(dir){
  lbIndex=(lbIndex+dir+lbImgs.length)%lbImgs.length;
  lbScale=1.5;lbX=0;lbY=0;
  renderLbImg();
}
function lbGoTo(idx){
  lbIndex=idx;lbScale=1.5;lbX=0;lbY=0;
  renderLbImg();
}
function renderLbImg(){
  const wrap=document.getElementById('lb-img-wrap');
  const src=lbImgs[lbIndex].cloneNode(true);
  const hint=src.querySelector('.gal-zoom-hint');
  if(hint)hint.remove();
  wrap.innerHTML='';
  src.style.cssText='width:auto;height:auto;max-width:90vw;max-height:80vh;display:flex;align-items:center;justify-content:center;aspect-ratio:3/4;background:transparent;cursor:inherit;overflow:visible;border:none;';
  src.querySelectorAll('svg').forEach(s=>{s.style.cssText='max-width:80vw;max-height:80vh;width:auto;height:auto;';});
  src.querySelectorAll('div').forEach(d=>{d.style.pointerEvents='none';});
  wrap.appendChild(src);
  applyLbTransform();
  document.getElementById('lb-counter').textContent=(lbIndex+1)+' / '+lbImgs.length;
  document.querySelectorAll('.lb-thumb-item').forEach((t,i)=>{
    t.classList.toggle('active',i===lbIndex);
  });
}
function applyLbTransform(){
  const w=document.getElementById('lb-img-wrap');
  w.style.transform=`translate(${lbX}px,${lbY}px) scale(${lbScale})`;
  const lbl=document.getElementById('lb-zoom-label');
  if(lbl)lbl.textContent=lbScale.toFixed(1)+'×';
}
function lbResetZoom(){lbScale=1.5;lbX=0;lbY=0;applyLbTransform();}
document.addEventListener('DOMContentLoaded',()=>{
  const stage=document.getElementById('lb-stage');
  if(!stage)return;
  stage.addEventListener('wheel',e=>{
    if(!document.getElementById('img-lightbox').classList.contains('open'))return;
    e.preventDefault();
    const delta=e.deltaY>0?-0.15:0.15;
    lbScale=Math.min(5,Math.max(1.5,lbScale+delta));
    if(lbScale===1.5){lbX=0;lbY=0;}
    applyLbTransform();
  },{passive:false});
  stage.addEventListener('mousedown',e=>{
    if(lbScale<1.5)return;
    lbDragging=true;lbDragSX=e.clientX-lbX;lbDragSY=e.clientY-lbY;
    stage.classList.add('dragging');
  });
  window.addEventListener('mousemove',e=>{
    if(!lbDragging)return;
    lbX=e.clientX-lbDragSX;lbY=e.clientY-lbDragSY;
    applyLbTransform();
  });
  window.addEventListener('mouseup',()=>{lbDragging=false;document.getElementById('lb-stage')&&document.getElementById('lb-stage').classList.remove('dragging');});
  let lastDist=0;
  stage.addEventListener('touchstart',e=>{
    if(e.touches.length===2){lastDist=Math.hypot(e.touches[0].clientX-e.touches[1].clientX,e.touches[0].clientY-e.touches[1].clientY);}
    else if(e.touches.length===1&&lbScale>1){lbDragging=true;lbDragSX=e.touches[0].clientX-lbX;lbDragSY=e.touches[0].clientY-lbY;}
  },{passive:true});
  stage.addEventListener('touchmove',e=>{
    if(e.touches.length===2){
      const dist=Math.hypot(e.touches[0].clientX-e.touches[1].clientX,e.touches[0].clientY-e.touches[1].clientY);
      const delta=(dist-lastDist)*0.01;lastDist=dist;
      lbScale=Math.min(5,Math.max(1.5,lbScale+delta));
      if(lbScale===1.5){lbX=0;lbY=0;}
      applyLbTransform();
    }else if(lbDragging&&e.touches.length===1){
      lbX=e.touches[0].clientX-lbDragSX;lbY=e.touches[0].clientY-lbDragSY;
      applyLbTransform();
    }
  },{passive:true});
  stage.addEventListener('touchend',()=>{lbDragging=false;});
  stage.addEventListener('dblclick',e=>{
    if(lbScale>1.5){lbScale=1.5;lbX=0;lbY=0;}
    else{lbScale=3;const r=stage.getBoundingClientRect();lbX=(r.width/2-e.clientX+r.left);lbY=(r.height/2-e.clientY+r.top);}
    applyLbTransform();
  });
});

/* ── SIZE GUIDE ── */
function openSzGuide(){document.getElementById('sz-drawer').classList.add('open');document.getElementById('sz-ov').classList.add('open');}
function closeSzGuide(){document.getElementById('sz-drawer').classList.remove('open');document.getElementById('sz-ov').classList.remove('open');}

function openSearch(){
  /* Mobilde /search sayfasına yönlendir */
  if(window.innerWidth < 768){
    window.location.href = '/search';
    return;
  }
  var box=document.getElementById('hd-search-box');
  var inp=document.getElementById('hd-search-input');
  if(!box||!inp)return;
  box.classList.add('expanded');
  setTimeout(function(){inp.focus();},50);
}

/* ── USER & SAVED PANELS ── */
function openUserPanel(){
  closeAllPanels(true);
  const body=document.getElementById('user-panel-body');
  if(userLoggedIn){
    body.innerHTML=`<div style="padding:8px 0 32px;"><p style="font-size:13px;color:var(--mid);margin-bottom:24px;">Hoş geldiniz. Hesap bilgilerinizi yönetin.</p><div style="border-bottom:1px solid var(--border);padding:16px 0;cursor:pointer;" onclick="showPage('iade')"><div style="font-size:11px;letter-spacing:0.1em;text-transform:uppercase;color:var(--navy);margin-bottom:3px;">Siparişlerim</div><div style="font-size:12px;color:var(--mid);">Son siparişlerinizi takip edin</div></div><div style="border-bottom:1px solid var(--border);padding:16px 0;cursor:pointer;" onclick="openSavedPanel()"><div style="font-size:11px;letter-spacing:0.1em;text-transform:uppercase;color:var(--navy);margin-bottom:3px;">Kaydedilenler (${savedItems.length})</div><div style="font-size:12px;color:var(--mid);">Beğendiklerinize göz atın</div></div><button class="form-submit" style="width:100%;margin-top:24px;background:transparent;color:var(--navy);border:1px solid var(--border);" onclick="fakeLogout()">Çıkış Yap</button></div>`;
  }else{
    body.innerHTML=`<div class="panel-empty"><div class="panel-empty-icon"><svg width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="var(--border)" stroke-width="1"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg></div><div class="panel-empty-title">Giriş Yapın</div><p class="panel-empty-text">Kayıtlı ürünlerinizi ve siparişlerinizi görmek için giriş yapın.</p><button class="panel-cta" onclick="closeAllPanels();showPage('giris')">Giriş Yap</button><div style="margin-top:16px;font-size:12px;color:var(--mid);">Hesabınız yok mu? <a onclick="closeAllPanels();showPage('kayit')" style="color:var(--navy);cursor:pointer;text-decoration:underline;text-underline-offset:2px;">Kayıt Olun</a></div></div>`;
  }
  document.getElementById('user-panel').classList.add('open');
  document.getElementById('panel-overlay').classList.add('open');
  document.body.style.overflow='hidden';
}
function openSavedPanel(){
  closeAllPanels(true);
  const body=document.getElementById('saved-panel-body');
  if(!userLoggedIn){
    body.innerHTML=`<div class="panel-empty"><div class="panel-empty-icon"><svg width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="var(--border)" stroke-width="1"><path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z"/></svg></div><div class="panel-empty-title">Kaydedilenler</div><p class="panel-empty-text">Beğendiğiniz pantolonları kaydetmek için önce giriş yapın.</p><button class="panel-cta" onclick="closeAllPanels();showPage('giris')">Giriş Yap</button></div>`;
  }else if(savedItems.length===0){
    body.innerHTML=`<div class="panel-empty"><div class="panel-empty-icon"><svg width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="var(--border)" stroke-width="1"><path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z"/></svg></div><div class="panel-empty-title">Henüz Kayıt Yok</div><p class="panel-empty-text">Beğendiğiniz ürünlerin yer imi ikonuna tıklayarak kaydedin.</p><button class="panel-cta" onclick="closeAllPanels();showPage('pantolonlar')">Koleksiyona Git</button></div>`;
  }else{
    body.innerHTML=savedItems.map(id=>{const p=products[id];return`<div class="saved-item"><div class="saved-img"><svg width="50" height="70" viewBox="0 0 130 180" fill="none"><path d="M35 0 L20 180 L57 180 L65 80 L73 180 L108 180 L93 0 Z" fill="${p.color}" opacity="0.7"/></svg></div><div><div class="saved-info-name">${p.name}</div><div class="saved-info-mat">${p.mat}</div><div class="saved-info-price">${p.price}</div></div><button class="saved-remove" onclick="removeSaved('${id}')"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M18 6L6 18M6 6l12 12"/></svg></button></div>`;}).join('');
  }
  document.getElementById('saved-panel').classList.add('open');
  document.getElementById('panel-overlay').classList.add('open');
  document.body.style.overflow='hidden';
}
function saveProd(id){
  if(!userLoggedIn){
    document.getElementById('fav-auth-overlay').classList.add('open');
    return;
  }
  if(!savedItems.includes(id)){savedItems.push(id);}
  const btn=document.getElementById('pdp-save-btn');
  if(btn&&currentPDP===id)btn.classList.add('saved');
  showFavToast();
}
function togglePdpSave(){
  if(!currentPDP)return;
  if(!userLoggedIn){
    document.getElementById('fav-auth-overlay').classList.add('open');
    return;
  }
  const btn=document.getElementById('pdp-save-btn');
  if(savedItems.includes(currentPDP)){
    savedItems=savedItems.filter(x=>x!==currentPDP);
    if(btn){btn.classList.remove('saved');btn.style.transform='';}
  } else {
    savedItems.push(currentPDP);
    if(btn){
      btn.classList.add('saved');
      btn.style.transform='scale(1.35)';
      setTimeout(()=>{btn.style.transform='scale(1)';},180);
    }
    showFavToast();
  }
}
function showFavToast(){
  const t=document.getElementById('fav-toast');
  if(!t)return;
  t.classList.add('show');
  clearTimeout(t._timer);
  t._timer=setTimeout(()=>t.classList.remove('show'),2800);
}
function closeFavAuth(e){
  const overlay=document.getElementById('fav-auth-overlay');
  if(e&&e.target!==overlay)return;
  overlay.classList.remove('open');
}
function removeSaved(id){savedItems=savedItems.filter(x=>x!==id);openSavedPanel();}
function closeAllPanels(keepOpen){
  if(!keepOpen){
    document.getElementById('user-panel').classList.remove('open');
    document.getElementById('saved-panel').classList.remove('open');
    document.getElementById('cart-panel').classList.remove('open');
    document.getElementById('panel-overlay').classList.remove('open');
    document.body.style.overflow='';
  }
}
function fakeLogin(){userLoggedIn=true;closeAllPanels();showPage('home');}
function fakeLogout(){userLoggedIn=false;savedItems=[];closeAllPanels();}

/* ── MISC ── */

/* ── STOK UYARI MODALİ ── */
let _stockSzLabel='';

function openStockModal(btn){
  _stockSzLabel=btn?btn.textContent.trim():'';
  const title=document.getElementById('stock-modal-title');
  if(title)title.textContent=_stockSzLabel?'Beden '+_stockSzLabel+' stok bildirimi':'Bu beden yakında gelecek';
  const content=document.getElementById('stock-modal-content');
  const success=document.getElementById('stock-modal-success');
  if(content){content.style.display='';} if(success){success.style.display='none';}
  const email=document.getElementById('stock-modal-email');
  if(email)email.value='';
  document.getElementById('stock-modal-overlay').classList.add('open');
  document.body.style.overflow='hidden';
  setTimeout(()=>{if(email)email.focus();},120);
}

function closeStockModal(e){
  if(e&&e.target!==document.getElementById('stock-modal-overlay'))return;
  document.getElementById('stock-modal-overlay').classList.remove('open');
  document.body.style.overflow='';
}

function submitStockAlert(){
  const email=document.getElementById('stock-modal-email');
  if(!email||!email.value.includes('@'))return;
  const content=document.getElementById('stock-modal-content');
  const success=document.getElementById('stock-modal-success');
  if(content)content.style.display='none';
  if(success)success.style.display='block';
  setTimeout(()=>{
    document.getElementById('stock-modal-overlay').classList.remove('open');
    document.body.style.overflow='';
  },2600);
}

// ── TICKER ──────────────────────────────────────────────────────────
let _tickerIdx = 0;
let _tickerTimer = null;
const _tickerDelay = 4000;

function tickerInit(){
  const msgs = document.querySelectorAll('.ticker-msg');
  if(!msgs.length) return;
  msgs.forEach(m=>m.classList.remove('active'));
  msgs[0].classList.add('active');
  _tickerTimer = setInterval(()=>tickerStep(1), _tickerDelay);
}

function tickerStep(dir){
  clearInterval(_tickerTimer);
  const msgs = document.querySelectorAll('.ticker-msg');
  msgs[_tickerIdx].classList.remove('active');
  _tickerIdx = (_tickerIdx + dir + msgs.length) % msgs.length;
  msgs[_tickerIdx].classList.add('active');
  _tickerTimer = setInterval(()=>tickerStep(1), _tickerDelay);
}

document.addEventListener('DOMContentLoaded', tickerInit);

// ── SEARCH ────────────────────────────────────────────────────────────
let _sdActive = -1;
let _searchAbortController = null;

function highlight(str, q){
  if(!q) return str;
  const re = new RegExp('('+q.replace(/[.*+?^${}()|[\]\\]/g,'\\$&')+')','gi');
  return str.replace(re,'<em>$1</em>');
}

async function searchSuggest(val){
  const dd = document.getElementById('search-dropdown');
  const q  = val.trim();
  _sdActive = -1;

  if(q.length < 2){ dd.classList.remove('visible'); dd.innerHTML=''; return; }

  if (_searchAbortController) {
    _searchAbortController.abort();
  }
  _searchAbortController = new AbortController();

  try {
    const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=5`, {
      signal: _searchAbortController.signal
    });
    
    if (!response.ok) return;
    const data = await response.json();
    const products = data.resources.results.products || [];

    if(!products.length){
      dd.innerHTML = '<div class="sd-empty">Ürün bulunamadı</div>';
      dd.classList.add('visible');
      return;
    }

    let inner = '<div class="sd-header">Ürünler</div>';
    products.forEach((p,i)=>{
      const imgHtml = p.image ? `<img src="${p.image}" style="width:100%;height:100%;object-fit:cover;">` : `<div style="width:100%;height:100%;background:#E0DBD2;"></div>`;
      
      inner += `<a href="${p.url}" class="sd-item" data-idx="${i}" style="text-decoration:none;color:inherit;display:flex;">
        <div class="sd-swatch" style="overflow:hidden;background:transparent;padding:0;">
          ${imgHtml}
        </div>
        <div class="sd-info">
          <div class="sd-name">${highlight(p.title, q)}</div>
        </div>
        <div class="sd-price">${p.price || ''}</div>
      </a>`;
    });
    inner += `<a href="/search?q=${encodeURIComponent(q)}" class="sd-all" style="display:block;text-decoration:none;">Tümünü Gör</a>`;
    dd.innerHTML = inner;
    dd.classList.add('visible');

  } catch (err) {
    if (err.name !== 'AbortError') {
      console.error('Search error:', err);
    }
  }
}

function sdAll(){
  const inp = document.getElementById('hd-search-input');
  if(inp && inp.value.trim()){
    window.location.href = `/search?q=${encodeURIComponent(inp.value.trim())}`;
  } else {
    window.location.href = '/collections/all';
  }
}

function searchKeyNav(e){
  const dd = document.getElementById('search-dropdown');
  const items = dd.querySelectorAll('.sd-item');
  if(!items.length) return;
  if(e.key==='ArrowDown'){
    e.preventDefault();
    _sdActive = Math.min(_sdActive+1, items.length-1);
    items.forEach((el,i)=>el.classList.toggle('hovered', i===_sdActive));
  } else if(e.key==='ArrowUp'){
    e.preventDefault();
    _sdActive = Math.max(_sdActive-1, 0);
    items.forEach((el,i)=>el.classList.toggle('hovered', i===_sdActive));
  } else if(e.key==='Enter'){
    if(_sdActive>=0 && items[_sdActive]){
      items[_sdActive].click();
    } else if(document.getElementById('hd-search-input').value.trim()){
      sdAll();
    }
  } else if(e.key==='Escape'){
    closeSearch();
  }
}

function toggleSearch(e){
  const box = document.getElementById('hd-search-box');
  const inp = document.getElementById('hd-search-input');
  if(!box.classList.contains('expanded')){
    box.classList.add('expanded');
    setTimeout(()=>inp.focus(),50);
    e.stopPropagation();
  }
}

function closeSearch(){
  const box = document.getElementById('hd-search-box');
  const inp = document.getElementById('hd-search-input');
  const dd  = document.getElementById('search-dropdown');
  box.classList.remove('expanded');
  if(inp) inp.value='';
  if(dd) { dd.classList.remove('visible'); dd.innerHTML=''; }
  _sdActive = -1;
}

document.addEventListener('click', function(e){
  const box = document.getElementById('hd-search-box');
  if(box && !box.contains(e.target)) closeSearch();
});
let playing=false;
function togglePlay(){playing=!playing;document.getElementById('play-label').textContent=playing?'Duraklat':'Videoyu Oynat';}

/* ── HERO CARD PARALLAX ──
   Hem mobil hem masaüstünde aktif. Mobilde daha düşük speed/maxDrop.
   Mobil pozisyonu CSS'teki `bottom:-30/-40px !important` ile kontrol edilir;
   JS sadece transform ekler.
*/
(function(){
  var _card=null,_hero=null,_header=null,_ticking=false,_scrollBound=false;
  var _mobileQuery=window.matchMedia('(max-width: 768px)');

  function getEls(){
    _card=document.querySelector('#page-home .hero-card');
    _hero=document.querySelector('#page-home .hero');
    _header=document.getElementById('prod-anchor');
  }

  function setup(){
    if(!_card||!_hero)return;
    var cardH=_card.offsetHeight;
    if(_mobileQuery.matches){
      /* Mobil: CSS'teki bottom değeri geçerli; sadece anchor padding'i ayarla */
      if(_header) _header.style.paddingTop=(cardH*0.5+28)+'px';
    }else{
      _card.style.bottom=(-cardH/2)+'px';
      if(_header) _header.style.paddingTop=(cardH+48)+'px';
    }
  }

  function onScroll(){
    if(!_ticking){
      requestAnimationFrame(function(){
        if(!_card)return;
        var cardH=_card.offsetHeight;
        var isMob=_mobileQuery.matches;
        var maxDrop=isMob?(cardH*0.4):(cardH/2+24);
        var speed=isMob?0.22:0.45;
        var drop=Math.min(window.scrollY*speed,maxDrop);
        _card.style.transform='translateX(-50%) translateY('+drop+'px)';
        _ticking=false;
      });
      _ticking=true;
    }
  }

  function init(){
    getEls();
    if(!_card)return;
    setup();
    if(!_scrollBound){
      window.addEventListener('scroll',onScroll,{passive:true});
      _scrollBound=true;
    }
    onScroll();
  }

  /* Resize event — orientation change ve pencere boyutu değişiminde yeniden hesapla */
  window.addEventListener('resize',function(){
    clearTimeout(window._nsParallaxRT);
    window._nsParallaxRT=setTimeout(init,120);
  });

  if(document.readyState==='complete'||document.readyState==='interactive'){
    setTimeout(init,0);
  } else {
    document.addEventListener('DOMContentLoaded',init);
  }
})();
function nextLook(){const dots=document.querySelectorAll('.look-dot');let active=0;dots.forEach((d,i)=>{if(d.classList.contains('active'))active=i;});dots.forEach(d=>d.classList.remove('active'));dots[(active+1)%dots.length].classList.add('active');}
function toggleSection(btn){const body=btn.nextElementSibling;const svg=btn.querySelector('svg');if(body.classList.contains('collapsed')){body.classList.remove('collapsed');if(svg)svg.style.transform='';}else{body.classList.add('collapsed');if(svg)svg.style.transform='rotate(-90deg)';}}

/* ── MEGA MENU ── */
let megaOpen=false;

function getMegaCats() {
  return window.nesetMegaMenuData || {};
}

function toggleMegaMenu(e){
  e.preventDefault();
  megaOpen?closeMegaMenu():openMegaMenu();
}
function openMegaMenu(){
  megaOpen=true;
  document.getElementById('mega-menu').classList.add('open');
  document.getElementById('mega-overlay').classList.add('open');
  document.getElementById('nav-miras').style.color='var(--text)';
  activateCat('kumashlar');
}
function closeMegaMenu(){
  megaOpen=false;
  document.getElementById('mega-menu').classList.remove('open');
  document.getElementById('mega-overlay').classList.remove('open');
  document.getElementById('nav-miras').style.color='';
}
function activateCat(cat){
  document.querySelectorAll('.mega-cat').forEach(el=>el.classList.remove('active'));
  const el=document.getElementById('mcat-'+cat);
  if(el)el.classList.add('active');
  
  const megaCats = getMegaCats();
  const data=megaCats[cat];
  if(!data)return;
  
  const center=document.getElementById('mega-center');
  center.innerHTML=`<div class="mega-center-eyebrow">${data.eyebrow}</div>`+
    data.items.map(item=>`<a class="mega-link" href="${item.url || '#'}" style="text-decoration:none;" onclick="closeMegaMenu()" onmouseenter="updateMegaPrev('${(item.prev||'').replace(/'/g,"\\'")}','${data.eyebrow}', '${item.img||''}')">
      ${item.label}${item.sub?`<span class="mega-link-sub">${item.sub}</span>`:''}
    </a>`).join('');
    
  if(data.items[0]){
    updateMegaPrev(data.items[0].prev, data.eyebrow, data.items[0].img);
  } else {
    updateMegaPrev('', data.eyebrow, '');
  }
}
function updateMegaPrev(title,label,imgSrc){
  const t=document.getElementById('mega-preview-title');
  const l=document.getElementById('mega-preview-label');
  const bg=document.getElementById('mega-preview-bg');
  
  if(t){t.style.opacity=0;setTimeout(()=>{t.textContent=title;t.style.opacity=1;},120);}
  if(l)l.textContent=label;
  
  if(bg){
    const svg = bg.querySelector('svg');
    if(imgSrc && imgSrc.trim()!==''){
      bg.style.backgroundImage = `url('${imgSrc}')`;
      bg.style.backgroundSize = 'cover';
      bg.style.backgroundPosition = 'center';
      if(svg) svg.style.display = 'none';
    } else {
      bg.style.backgroundImage = 'none';
      if(svg) svg.style.display = 'block';
    }
  }
}

/* ── VIDEO LAZY LOAD ── */
function loadVid(block){
  const ytId=block.dataset.youtubeId;
  if(!ytId||ytId.trim()===''){
    const ph=block.querySelector('.video-ph-sub');
    if(ph){ph.textContent='Lütfen Shopify panelinden YouTube video ID\'si ekleyin.';ph.style.color='rgba(255,255,255,.6)';}
    return;
  }
  block.innerHTML=`<iframe src="https://www.youtube.com/embed/${ytId}?autoplay=1&rel=0&modestbranding=1" frameborder="0" allow="autoplay;encrypted-media;gyroscope;picture-in-picture" allowfullscreen style="position:absolute;inset:0;width:100%;height:100%;"></iframe>`;
}
const io=new IntersectionObserver(entries=>{entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:0.08});
document.querySelectorAll('.reveal').forEach(el=>io.observe(el));
const ioImg=new IntersectionObserver(entries=>{entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');ioImg.unobserve(e.target);}});},{threshold:0,rootMargin:'0px 0px 80px 0px'});
function applyImgReveal(){
  document.querySelectorAll('.ed3-img-wrap,.inside-img-wrap,.ed-section-img,.page-full-img,.store-img').forEach(el=>{
    if(!el.closest('.pdp-layer')&&!el.dataset.ri){
      el.dataset.ri='1';
      el.classList.add('reveal-img');
      ioImg.observe(el);
    }
  });
}
applyImgReveal();

/* ══════════════════════════════════════════
   PANTOLONLAR FİLTRE SİSTEMİ
══════════════════════════════════════════ */
const allProds=[
  {id:'dustin', name:'Dustin Pantolon', mat:'İpek, Pamuk, Keten', price:18500, pStr:'₺ 18.500', type:'regular', fabrics:['ipek','pamuk','keten'], colors:['lacivert','tas'], svgC:'#6B8FA8', bg:'#D4C9B5', isNew:false},
  {id:'pushkar', name:'Pushkar Pantolon', mat:'Pamuk, Keten', price:13400, pStr:'₺ 13.400', type:'relaxed', fabrics:['pamuk','keten'], colors:['zeytinyagi'], svgC:'#7A8060', bg:'#DDD6C8', isNew:false},
  {id:'marlyn', name:'Marlyn Pantolon', mat:'Keten', price:15900, pStr:'₺ 15.900', type:'slim', fabrics:['keten'], colors:['adacayi','fildisi'], svgC:'#7A9882', bg:'#E0DBD2', isNew:false},
  {id:'quarona', name:'Quarona Beş Cepli', mat:'Pamuk, Keten', price:14200, pStr:'₺ 14.200', type:'bescepti', fabrics:['pamuk','keten'], colors:['deve','lacivert'], svgC:'#B8956A', bg:'#E4DDD0', isNew:false},
  {id:'altai', name:'Altai Pantolon', mat:'İpek, Keten', price:22000, pStr:'₺ 22.000', type:'formal', fabrics:['ipek','keten'], colors:['antrasit','lacivert'], svgC:'#5A6070', bg:'#2A3A4E', isNew:true},
  {id:'belem', name:'Belem Pantolon', mat:'Pamuk', price:11500, pStr:'₺ 11.500', type:'regular', fabrics:['pamuk'], colors:['fildisi','tas'], svgC:'#C4B8A0', bg:'#EAE4DC', isNew:true},
  {id:'ceylan', name:'Ceylan Pantolon', mat:'Keten', price:17800, pStr:'₺ 17.800', type:'formal', fabrics:['keten'], colors:['ekru'], svgC:'#D4C8B0', bg:'#E8E0D0', isNew:true},
  {id:'destan', name:'Destan Pantolon', mat:'Pamuk, Keten', price:12900, pStr:'₺ 12.900', type:'slim', fabrics:['pamuk','keten'], colors:['tas','lacivert'], svgC:'#A09080', bg:'#D8D0C4', isNew:false},
];

const typeLabels={regular:'Regular Fit',slim:'Slim Fit',relaxed:'Relaxed Fit',formal:'Formal',bescepti:'Beş Cepli'};
const fabricLabels={keten:'Keten',pamuk:'Pamuk',ipek:'İpek'};
const colorLabels={lacivert:'Lacivert',fildisi:'Fildişi',adacayi:'Adaçayı',deve:'Deve Tüyü',zeytinyagi:'Zeytinyağı',tas:'Taş',antrasit:'Antrasit',ekru:'Ekru'};
const swatchHex={lacivert:'#1A2B42',fildisi:'#E8E2D8',adacayi:'#7A9882',deve:'#C4A87A',zeytinyagi:'#7A8060',tas:'#9C8870',antrasit:'#3A3A3A',ekru:'#E8DCC8'};
const priceLabels={'10-15':'₺10.000 – ₺15.000','15-20':'₺15.000 – ₺20.000','20+':'₺20.000 +'};

let activeFilters={type:new Set(),fabric:new Set(),price:new Set(),color:new Set()};
let sortOrder='default';
let collInit=false;

function initCollPage(){
  if(!collInit){collInit=true;}
  renderCollGrid();
}

function prodSvg(p){
  const dark=p.bg==='#2A3A4E';
  const fill=dark?`rgba(232,228,220,0.20)`:p.svgC;
  const op=dark?'1':'0.72';
  return`<svg width="130" height="200" viewBox="0 0 130 240" fill="none">
    <rect x="35" y="0" width="60" height="11" rx="3" fill="${fill}" opacity="0.5"/>
    <path d="M35 11 L22 240 L57 240 L65 100 L73 240 L108 240 L95 11 Z" fill="${fill}" opacity="${op}"/>
    <line x1="65" y1="100" x2="65" y2="240" stroke="${p.svgC}" stroke-width="1.5" opacity="0.3"/>
  </svg>`;
}

function renderCollGrid(){
  return; // DISABLED: Shopify liquid handles collection rendering
  let prods=[...allProds];
  prods=prods.filter(p=>{
    if(activeFilters.type.size>0&&!activeFilters.type.has(p.type))return false;
    if(activeFilters.fabric.size>0){const ok=[...activeFilters.fabric].some(f=>p.fabrics.includes(f));if(!ok)return false;}
    if(activeFilters.color.size>0){const ok=[...activeFilters.color].some(c=>p.colors.includes(c));if(!ok)return false;}
    if(activeFilters.price.size>0){
      const ok=[...activeFilters.price].some(r=>{
        if(r==='10-15')return p.price>=10000&&p.price<15000;
        if(r==='15-20')return p.price>=15000&&p.price<20000;
        if(r==='20+')return p.price>=20000;
        return false;
      });
      if(!ok)return false;
    }
    return true;
  });
  if(sortOrder==='asc')prods.sort((a,b)=>a.price-b.price);
  else if(sortOrder==='desc')prods.sort((a,b)=>b.price-a.price);
  else if(sortOrder==='alpha')prods.sort((a,b)=>a.name.localeCompare(b.name,'tr'));

  const grid=document.getElementById('coll-grid');
  const noRes=document.getElementById('coll-no-results');
  const countEl=document.getElementById('coll-result-count');
  const heroCount=document.getElementById('coll-hero-count');

  const total=prods.length;
  countEl.textContent=`${total} ürün listeleniyor`;
  if(heroCount)heroCount.textContent=`${allProds.length} ürün`;

  if(total===0){
    grid.innerHTML='';grid.style.display='none';
    noRes.style.display='block';
  }else{
    noRes.style.display='none';grid.style.display='grid';
    grid.innerHTML=prods.map(p=>`
      <div class="prod-card" onclick="openPDP('${p.id}')">
        <div class="pimg-wrap">
          <div class="psvg-wrap" style="background:${p.bg.startsWith('#')?p.bg:'#'+p.bg};">
            ${prodSvg(p)}
          </div>
        </div>
        ${p.isNew?'<div class="prod-tag">Yeni</div>':''}
        <button class="pbookmark" onclick="event.stopPropagation();saveProd('${p.id}')">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z"/></svg>
        </button>
        <div class="pcta"><button onclick="event.stopPropagation();openPDP('${p.id}')">Hızlı Ekle</button></div>
        <div class="pinfo">
          <div class="pmat">${p.mat}</div>
          <div class="pname">${p.name}</div>
          <div class="pprice">${p.pStr}</div>
          <div class="pcard-swatches">${p.colors.map(c=>`<span class="pcard-sw" style="background:${swatchHex[c]||'#ccc'};${(c==='fildisi'||c==='ekru')?'border-color:rgba(0,0,0,.1);':''}" title="${colorLabels[c]||c}"></span>`).join('')}</div>
        </div>
      </div>`).join('');
  }
  updateChips();
  updateCheckboxes();
}

function toggleFilter(cat,val){
  const s=activeFilters[cat];
  if(s.has(val))s.delete(val);else s.add(val);
  renderCollGrid();
}

function clearAllFilters(){
  activeFilters={type:new Set(),fabric:new Set(),price:new Set(),color:new Set()};
  renderCollGrid();
}

function sortProds(val){sortOrder=val;renderCollGrid();}

function updateChips(){
  const bar=document.getElementById('chips-bar');
  const chips=[];
  activeFilters.type.forEach(v=>chips.push({cat:'type',val:v,label:typeLabels[v]||v}));
  activeFilters.fabric.forEach(v=>chips.push({cat:'fabric',val:v,label:fabricLabels[v]||v}));
  activeFilters.color.forEach(v=>chips.push({cat:'color',val:v,label:colorLabels[v]||v}));
  activeFilters.price.forEach(v=>chips.push({cat:'price',val:v,label:priceLabels[v]||v}));

  if(chips.length===0){bar.classList.add('empty');bar.innerHTML='';return;}
  bar.classList.remove('empty');
  bar.innerHTML=chips.map(c=>`
    <button class="filter-chip" onclick="toggleFilter('${c.cat}','${c.val}')">
      ${c.label}
      <span class="chip-x"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg></span>
    </button>`).join('')+`<button class="clear-all-chip" onclick="clearAllFilters()">Tümünü Sıfırla</button>`;
}

function updateCheckboxes(){
  const cats=['type','fabric','price','color'];
  cats.forEach(cat=>{
    const vals=cat==='price'?['10-15','15-20','20+']:cat==='type'?['regular','slim','relaxed','formal','bescepti']:cat==='fabric'?['keten','pamuk','ipek']:['lacivert','fildisi','adacayi','deve','zeytinyagi','tas','antrasit','ekru'];
    vals.forEach(v=>{
      const chk=document.getElementById(`fchk-${cat}-${v.replace('+','plus')}`);
      if(chk){if(activeFilters[cat].has(v))chk.classList.add('on');else chk.classList.remove('on');}
      const mchk=document.getElementById(`mfchk-${cat}-${v.replace('+','plus')}`);
      if(mchk){if(activeFilters[cat].has(v))mchk.classList.add('on');else mchk.classList.remove('on');}
      if(cat==='color'){
        const csw=document.getElementById(`csw-${v}`);
        if(csw){if(activeFilters.color.has(v))csw.classList.add('on');else csw.classList.remove('on');}
        const mcsw=document.getElementById(`mcsw-${v}`);
        if(mcsw){if(activeFilters.color.has(v))mcsw.classList.add('on');else mcsw.classList.remove('on');}
      }
    });
  });
}

document.querySelectorAll('.csw-f').forEach(el=>{
  el.addEventListener('mouseenter',()=>{
    const lbl=document.getElementById('color-hover-label');
    if(lbl)lbl.textContent=el.getAttribute('title')||'';
  });
  el.addEventListener('mouseleave',()=>{
    const lbl=document.getElementById('color-hover-label');
    if(lbl)lbl.textContent='';
  });
});

function openFDrawer(){
  document.getElementById('fdrawer').classList.add('open');
  document.getElementById('fdrawer-overlay').classList.add('open');
  document.body.style.overflow='hidden';
}
function closeFDrawer(){
  document.getElementById('fdrawer').classList.remove('open');
  document.getElementById('fdrawer-overlay').classList.remove('open');
  document.body.style.overflow='';
}

/* ── HOTSPOT CURSOR ── */
(function(){
  var hs=document.getElementById('ns-hotspot');
  if(!hs)return;
  var raf=null;
  var zones='.pimg-wrap,.gal-img,.ed3-img-wrap,.inside-img-wrap,.look-photo-inner,.pdp-rec-img,.lb-stage';
  function move(x,y){hs.style.left=x+'px';hs.style.top=y+'px';}
  document.addEventListener('mousemove',function(e){
    if(!hs.classList.contains('on'))return;
    if(raf)cancelAnimationFrame(raf);
    raf=requestAnimationFrame(function(){move(e.clientX,e.clientY);});
  });
  function on(e){move(e.clientX,e.clientY);hs.classList.add('on');this.style.cursor='none';}
  function off(){hs.classList.remove('on');this.style.cursor='';}
  function attach(){
    document.querySelectorAll(zones).forEach(function(el){
      if(el.dataset.hs)return;
      el.dataset.hs='1';
      el.addEventListener('mouseenter',on);
      el.addEventListener('mousemove',function(e){
        if(raf)cancelAnimationFrame(raf);
        raf=requestAnimationFrame(function(){move(e.clientX,e.clientY);});
      });
      el.addEventListener('mouseleave',off);
    });
  }
  attach();
  var _r=window.renderCollGrid;
  if(typeof _r==='function')window.renderCollGrid=function(){_r.apply(this,arguments);setTimeout(attach,80);};
  var _o=window.openPDP;
  if(typeof _o==='function')window.openPDP=function(){_o.apply(this,arguments);setTimeout(attach,150);};
})();

/* ══ SHOPIFY OVERRIDES ══
   SPA fonksiyonlarını Shopify URL yapısına yönlendirir.
   openPDP artık kullanılmıyor — ürün kartları doğrudan <a href> kullanıyor.
*/
window.showPage=function(id){
  var m={
    'home':'/',
    'pantolonlar':'/collections/pantolonlar',
    'koleksiyonlar':'/pages/koleksiyonlar',
    'miras':'/pages/miras',
    'keten':'/pages/keten',
    'zanaat':'/pages/zanaat',
    'surdurulebilirlik':'/pages/surdurulebilirlik',
    'kampanyalar':'/pages/kampanyalar',
    'magazalar':'/pages/magazalar',
    'iletisim':'/pages/iletisim',
    'sss':'/pages/sss',
    'kariyer':'/pages/kariyer',
    'hizmetler':'/pages/hizmetler',
    'iade':'/pages/iade',
    'kargo':'/pages/kargo',
    'uyumluluk':'/pages/uyumluluk',
    'yasal':'/pages/yasal',
    'gizlilik':'/pages/gizlilik',
    'erisim':'/pages/erisim',
    'ipek':'/pages/ipek',
    'pamuk':'/pages/pamuk',
    'pamuk-keten':'/pages/pamuk-keten',
    'kesim-kalip':'/pages/kesim-kalip',
    'el-dikisi':'/pages/el-dikisi',
    'kalite-kontrol':'/pages/kalite-kontrol',
    'atolye-mirasi':'/pages/atolye-mirasi',
    'dogal-lif':'/pages/dogal-lif',
    'yerel-uretim':'/pages/yerel-uretim',
    'uzun-omurlu':'/pages/uzun-omurlu',
    'seffaf-tedarik':'/pages/seffaf-tedarik',
    'iy2026':'/pages/iy2026',
    'sk2025':'/pages/sk2025',
    'arsiv':'/pages/arsiv',
    'giris':'/account/login',
    'kayit':'/account/register'
  };
  window.location.href=m[id]||('/pages/'+id);
};
window.goHome=function(){window.location.href='/';};
/* openPDP: artık ürün kartları <a href="{{ product.url }}"> kullanıyor.
   Bu fonksiyon sadece eski kodla uyumluluk için kalıyor. */
window.openPDP=function(id){
  /* Ürün handle'ını Shopify'dan çözmek için collections API kullan */
  window.location.href='/collections/pantolonlar';
};
window.acceptCookies=function(){localStorage.setItem('ns_cookie','accept');var b=document.getElementById('cookie-banner');if(b)b.classList.remove('show');};
window.rejectCookies=function(){localStorage.setItem('ns_cookie','reject');var b=document.getElementById('cookie-banner');if(b)b.classList.remove('show');};
